import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useGlobalFilter, usePagination, useTable } from "react-table";
import { CourseApiCalls } from "../../apis/CourseApiCalls";
import EditCourseModal from "../../components/modals/EditCourseModal";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import NormalPagination from "../../components/pagination/NormalPagination";
import { ReactComponent as ViewIcon } from "../../images/View.svg";
import { ReactComponent as EditIcon } from "../../images/pencil.svg";
import { ReactComponent as DeleteIcon } from "../../images/trash.svg";
import {ReactComponent as NoResultIllustration} from "../../images/no_result.svg";
import {
    COURSE_CHARACTER_LIMIT,
    DEFAULT_ROWS_PER_PAGE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import styles from "./ManageCourses.module.css";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import classes from "../Report/Report.module.css";

export default React.memo(CourseTable);
function CourseTable({ data = [], setData, columns = [], pageIdx=0, globalFilterObj = {}, getCourses, sortCourseName, sortCourseCode, courseNameSort, courseCodeSort, enrolledMemberSort, sortEnrolledMembers}) {
    const { t } = useTranslation();
    // const {loading} = useLoading();
    const history = useHistory();
    const [modalShow, setModalShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [scrollableContainer, setScrollableContainer] = useState(false);
    const [currentCourseId, setCurrentCourseId] = useState("");
    const { deleteCourse } = CourseApiCalls();
    const [currentRow, setCurrentRow] = useState(null);
    const [sortSelected, setSortSelected] = useState(-1); // sorted by date but not displayed
    const [sortedBy, setSortedBy] = useState("");


    const filterCustomize = (rows, columnIds, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";
        // const filteredDate = globalFilterValue.date;
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.courseName && values.courseName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (values.courseCode && values.courseCode.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            return false;
        });
        // .filter(r => {
        //     if (!filteredDate) {
        //         return true;
        //     }
        //     const values = r.values;
        //     return values.startDate && values.startDate >= filteredDate;
        // });
    };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex },
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: pageIdx, pageSize: DEFAULT_ROWS_PER_PAGE },
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);

    useEffect(() => {
        setGlobalFilter(globalFilterObj);
    }, [data, globalFilterObj]);

    useEffect(() => {
        if (!pageOptions.length) {
            gotoPage(0);
        } else if (pageIdx < pageOptions.length) {
            gotoPage(pageIdx);
        } else {
            gotoPage(pageIdx - 1);
        }
    }, [data, pageIdx, pageOptions]);

    useEffect(() => {
        const container = document.getElementById("manage-course-page-container");
        setScrollableContainer(container.scrollWidth > container.clientWidth || container.scrollHeight > container.clientHeight);
    }, [data]);

    const onView = (courseId) => {
        history.push(`/course/content/${courseId}`);
    }

    const onDelete = (courseId) => {
        setCurrentCourseId(courseId);
        setShowDeleteModal(true);
        // if (!window.confirm("Are you sure you want to delete this course?")) {
        //     return;
        // }
        // const res = await deleteCourse(courseId);
        // if (res.success) {
        //     getCourses(pageIndex);
        // }
    }

    const handleDelete = async () => {
        const res = await deleteCourse(currentCourseId);
        if (res.success) {
            getCourses(pageIndex);
        }
    };

    const onEdit = (rowData, courseId) => {
        setCurrentRow(rowData);
        setCurrentCourseId(courseId)
        setModalShow(true);
    }

    const loadCourse = () => {
        getCourses(pageIndex);
    }

    const deleteCourseConfig = {
        title: t("course.deleteCourseTitle"),
        okText: t("common.delete"),
        cancelText: t("common.cancel"), 
        submit: () => {
            handleDelete();
        },
        close:  () => {
            setShowDeleteModal(false);
        }, 
    };


    return (
        <>
            <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                    <Table hover {...getTableProps()}>
                        <thead>
                        {headerGroups.map((headerGroup, headerIdx) => (
                            <tr key={headerIdx} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, idx) => {
                                    if (column.Header !== t("common.actionsLabel")) {
                                        return (
                                            <TableSortHeaderNew
                                                key={idx}
                                                data={data}
                                                setData={setData}
                                                sortedBy={sortedBy}
                                                setSortedBy={setSortedBy}
                                                propertyName={column.id}
                                                getProperty={(item) => item[column.id].toString()}
                                                label={column.Header}
                                                {...{
                                                    // ...column.getHeaderProps(),
                                                    key: column.id,
                                                    style: {
                                                        width: column.width,
                                                        textAlign: 'left',
                                                        backgroundClip: "padding-box",

                                                    }
                                                }}
                                            >
                                                <span style={{paddingLeft: column.Header === t("course.courseNameLabel") ? 10 : undefined}}>

                                                    {column.Header}
                                                </span>
                                            </TableSortHeaderNew>
                                        );
                                    } else {
                                        return (
                                            <th
                                                key={idx}
                                                {...column.getHeaderProps({
                                                    style: {
                                                        width: column.width,
                                                        textAlign: column.render('Header') === t("common.actionsLabel") ? 'center' : 'left'
                                                    }
                                                })}
                                            >
                                                <span className={ classes.tableCell}>
                                                    {column.Header}
                                                </span>
                                            </th>
                                        );
                                    }
                                })}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {page && page.length !== 0 ? page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell, index) => {
                                        if (cell.column.Header === t("common.actionsLabel")) {
                                            return (
                                                <td {...cell.getCellProps()} style={{textAlign: "center"}}>
                                                    <YuJaKebabMenuNew triggerAriaLabel={`${t("accessibility.actionsForPrefix")} ${row.original.courseName}`}>
                                                        <YuJaKebabMenuNew.Menu>
                                                            <YuJaKebabMenuNew.Item onClick={() => onView(cell.row.values['courseId'])}>
                                                                <ViewIcon style={{width: 18, marginRight: 5}}/>{t("common.view")}
                                                            </YuJaKebabMenuNew.Item>
                                                            <YuJaKebabMenuNew.Item onClick={() => onEdit(cell.row.values, cell.row.values['courseId'])}>
                                                                <EditIcon style={{width: 18, marginRight: 5}}/>{t("common.edit")}
                                                            </YuJaKebabMenuNew.Item>
                                                            <YuJaKebabMenuNew.Item onClick={() => onDelete(cell.value)}>
                                                                <DeleteIcon style={{width: 18, marginRight: 5}}/> {t("common.delete")}
                                                            </YuJaKebabMenuNew.Item>
                                                        </YuJaKebabMenuNew.Menu>
                                                    </YuJaKebabMenuNew>
                                                </td>
                                            );
                                        } else {
                                            return (
                                                <td title={cell.value && cell.value.length > COURSE_CHARACTER_LIMIT ? cell.value : ""}
                                                    {...cell.getCellProps({style: {wordBreak: 'break-word'}})}
                                                >
                                                    <span className={cell.column.Header === t("course.courseNameLabel") ? styles.nameCell : styles.tableCell}>
                                                        {cell.value && cell.value.length > COURSE_CHARACTER_LIMIT ?
                                                            cell.value.substring(0, COURSE_CHARACTER_LIMIT) + "..." :
                                                            cell.value
                                                        }
                                                    </span>
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            )
                        }) :
                            <tr>
                                <td colSpan="4" className={styles.noData} style={{boxShadow: "none"}}>
                                    <div style={{height: 450, display: "flex", flexDirection: "column", alignItems: "center", color: "#000"}}>
                                        <div style={{flex: 1}}/>
                                        <NoResultIllustration/>
                                        <div style={{fontSize: 20, lineHeight: 1.4, marginTop: 40, fontWeight: "600"}}> {t("course.noResultsFound")} </div>
                                        <div style={{flex: 1}}/>
                                    </div>
                                </td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                </div>

                {page && page.length !== 0 &&
                    <div className={styles.paginationContainer}>
                        <NormalPagination
                            pageCount={pageCount}
                            pageIndex={pageIndex}
                            pageOptions={pageOptions}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            gotoPage={gotoPage}
                        />
                    </div>
                }
            </div>
            <EditCourseModal
                show={modalShow}
                setModalShow={setModalShow}
                rowData={currentRow}
                courseId={currentCourseId}
                loadCourse={loadCourse}
            />
            <YuJaGeneralAlert show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={t("course.deleteConfirm")}
                config={deleteCourseConfig}
                AlertType={t("common.delete")}/>
            {/* <Modal
				id="delete-modal"
				show={showDeleteModal}
				onHide={() => setShowDeleteModal(false)}
				aria-labelledby="contained-modal-title-vcenter"
				backdrop={loading ? "static" : true}
				// dialogClassName="delete-modal"
            >
				<Spin tip="Loading..." size="large" spinning={loading}>
					<ModalClose tabIndex={0} onClick={() => setShowDeleteModal(false)} className="modal-close" />
					<Modal.Header style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<Modal.Title tabIndex={0}>
                            {t("course.deleteCourseTitle")}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
                        <div tabIndex={0}>{t("course.deleteConfirm")}</div>
					</Modal.Body>
                    <Modal.Footer>
						<button className="modal-button-cancel" tabIndex={0} onClick={() => setShowDeleteModal(false)}>
							{t("common.cancel")}
						</button>
						<button
                            tabIndex={0}
							className="modal-button-submit"
							onClick={handleDelete}
						>
							{t("common.delete")}
						</button>
					</Modal.Footer>
				</Spin>
			</Modal> */}
        </>
    );
}
